import React from 'react';
import { FaLinkedin, FaYoutube } from 'react-icons/fa';
import type { FC } from 'react';

interface SocialLink {
  href: string;
  icon: FC<React.SVGProps<SVGSVGElement>>;
  label: string;
  hoverColor: string;
}

const socialLinks: SocialLink[] = [
  {
    href: 'https://www.linkedin.com/company/one-pacific?originalSubdomain=hk',
    icon: FaLinkedin,
    label: 'LinkedIn',
    hoverColor: 'hover:text-blue-500',
  },
  {
    href: 'https://www.youtube.com/channel/UCdL5vUMIFKfveFIp2cUC1OA',
    icon: FaYoutube,
    label: 'Youtube',
    hoverColor: 'hover:text-blue-500',
  },
];

const SocialLinks: FC = () => {
  return (
    <ul className="m-0 flex list-none items-center space-x-6 p-0">
      {socialLinks.map(({ href, icon: Icon, label, hoverColor }) => (
        <li key={label}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-blue-400 ${hoverColor} ga-social transition-colors`}
            aria-label={label}
          >
            <Icon className="h-6 w-6" aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
